import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { Play, X } from 'lucide-react';
import '../../components/subPages.css';
import Navbar from '../Navbar/Navbar';
import { db } from '../firebase/firebase-config';
import Footer from '../Footer/Footer';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const VideosPage = () => {
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [heroImage, setHeroImage] = useState('');
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { lang } = useLanguage();

  useEffect(() => {
    const fetchData = async () => {
      // 1. Tüm Videoları Çek
      const videoQ = query(collection(db, "videos"), orderBy("createdAt", "desc"));
      const videoSnapshot = await getDocs(videoQ);
      setVideos(videoSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      // 2. Hero için Slider Görselini Çek
      const sliderQ = query(collection(db, "sliders"), orderBy("createdAt", "desc"), limit(1));
      const sliderSnapshot = await getDocs(sliderQ);
      if (!sliderSnapshot.empty) {
        setHeroImage(sliderSnapshot.docs[0].data().url);
      }
    };

    fetchData();
  }, []);

  const getEmbedUrl = (url) => {
    const videoId = url.split('v=')[1]?.split('&')[0] || url.split('/').pop();
    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  // KANKA: Firestore'dan gelen video başlığını dile göre seçen fonksiyon
  const getVideoTitle = (video) => {
    if (lang === 'AR') return video.titleAr || video.titleEn || video.title;
    if (lang === 'EN') return video.titleEn || video.title;
    return video.title;
  };

  return (
    <div className="subpage-wrapper">
      <Navbar />
      
      {/* Dinamik Arka Planlı Hero Section */}
      <section 
        className="subpage-hero" 
        style={{ backgroundImage: `url(${heroImage || 'https://images.unsplash.com/photo-1516467508483-a7212febe31a?q=80&w=2000'})` }}
      >
        <div className="hero-overlay">
          {/* Başlıkları dile göre dinamik yapıyoruz kanka */}
          <h1>
            {lang === 'TR' ? "Video " : lang === 'AR' ? "معرض " : "Video "} 
            <span>{lang === 'TR' ? "Galerisi" : lang === 'AR' ? "الفيديو" : "Gallery"}</span>
          </h1>
          <p>
            {lang === 'TR' 
              ? "Modern üretim tesisimizden ve faaliyetlerimizden kareler." 
              : lang === 'AR'
              ? "لقطات من منشأة الإنتاج الحديثة لدينا وأنشطتنا."
              : "Scenes from our modern production facility and activities."}
          </p>
        </div>
      </section>

      {/* Video Listesi */}
      <div className="container page-content">
        <div className="video-display-grid">
          {videos.map((video) => (
            <div key={video.id} className="premium-video-card minimalist" onClick={() => setSelectedVideo(video)}>
              <div className="img-wrapper">
                <img src={`https://img.youtube.com/vi/${video.url.split('v=')[1]?.split('&')[0] || video.url.split('/').pop()}/hqdefault.jpg`} alt={video.title} />
                <div className="play-icon-overlay"><Play size={32} fill="white" /></div>
              </div>
              <div className="card-info">
                 <h3>
                   {/* Firestore'dan gelen dinamik başlık seçimi */}
                   {getVideoTitle(video)}
                 </h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Video Popup (Sayfa İçi Oynatıcı) */}
      {selectedVideo && (
        <div className="video-modal-overlay" onClick={() => setSelectedVideo(null)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="video-modal-header">
              <h3>{getVideoTitle(selectedVideo)}</h3>
              <button className="close-modal-btn" onClick={() => setSelectedVideo(null)}><X size={28} /></button>
            </div>
            <div className="iframe-wrapper">
              <iframe 
                src={getEmbedUrl(selectedVideo.url)} 
                title={selectedVideo.title} 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
      <Footer/>
    </div>
  );
};

export default VideosPage;